import css from 'styled-jsx/css';
import { colors } from '../../theme/theme';

const style = css`
  .fuel-transaction-drawer-body {
    background: ${colors.white};
    min-height: 100%;
  }
  .fuel-transaction-name-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    padding: 8px 24px 24px;
    background: ${colors.backgroundContentMain};
  }
  .name {
    color: ${colors.black};
    font-size: 28px;
    font-weight: 500;
    margin-bottom: 0;
  }
`;

export default style;
